import { memo } from "react";
import { Box, type SxProps, type Theme } from "@mui/material";

interface IShadowProps {
    shouldShow: boolean;
    shadowProps?: SxProps<Theme>;
}

const Shadow = memo(function Shadow({ shouldShow, shadowProps = {} }: IShadowProps) {
    return (
        <Box
            sx={{
                opacity: shouldShow ? 1 : 0,
                transition: "opacity 0.3s, transform 0.3s",
                position: "absolute",
                bottom: 0,
                left: theme => theme.spacing(1),
                right: theme => theme.spacing(1),
                height: theme => theme.spacing(7),
                pointerEvents: "none",
                width: "calc(100% - 34px)",
                background: "linear-gradient(176deg, rgba(255, 255, 255, 0.00) 3.31%, rgba(255, 255, 255, 0.75) 34.55%, #FFF 96.71%)",
                ...shadowProps,
            }}
        />
    );
});

Shadow.displayName = "Shadow";

export { Shadow, type IShadowProps };
